import { render } from "./ModulosPage.vue?vue&type=template&id=21e8bae6"
import script from "./ModulosPage.vue?vue&type=script&lang=js"
export * from "./ModulosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__